//Plugins

/* v1.4 */
/* https://github.com/farinspace/jquery.imgpreload */
if("undefined"!=typeof jQuery){(function(a){a.imgpreload=function(b,c){c=a.extend({},a.fn.imgpreload.defaults,c instanceof Function?{all:c}:c);if("string"==typeof b){b=new Array(b)}var d=new Array;a.each(b,function(e,f){var g=new Image;var h=f;var i=g;if("string"!=typeof f){h=a(f).attr("src");i=f}a(g).bind("load error",function(e){d.push(i);a.data(i,"loaded","error"==e.type?false:true);if(c.each instanceof Function){c.each.call(i)}if(d.length>=b.length&&c.all instanceof Function){c.all.call(d)}a(this).unbind("load error")});g.src=h})};a.fn.imgpreload=function(b){a.imgpreload(this,b);return this};a.fn.imgpreload.defaults={each:null,all:null}})(jQuery)}

arrayMax = function( array ){
    return Math.max.apply( Math, array );
};


//Regular Code
function supportsSVG() {
    return !! document.createElementNS && !! document.createElementNS('http://www.w3.org/2000/svg','svg').createSVGRect;
}
if (supportsSVG()) {
    document.documentElement.className += ' svg';
} else {
    document.documentElement.className += ' no-svg';
}

function substitutePngsForSvgs(){
  if (!supportsSVG()) {

    var imgs = document.getElementsByTagName('img');
    var dotSVG = /.*\.svg$/;
    for (var i = 0; i != imgs.length; ++i) {
        if(imgs[i].src.match(dotSVG)) {
          var $img = $(imgs[i]);
          var pngFallbackSrc = $img.data('png-fallback');
          if(typeof pngFallbackSrc != 'undefined'){
            $img.attr('src',pngFallbackSrc);
          }
        }
    }
  }
}

substitutePngsForSvgs(); //run once at page load, accessible at window.substitutePngsForSvgs() afterward

$(document).ready(function(){

  $('.carousel').each(function(){

    var thisCarousel = $(this);

    if(thisCarousel.length > 0){

      var carouselItems = thisCarousel.find('.item');

      if(carouselItems.length >=1){

        function resizeCarousel(){
          var windowWidth = $(window).width();
          if (windowWidth <= 767) {

            var heights = [];
            carouselItems.each(function(){
              heights.push( $(this).height() );
            });

            //console.log(heights,arrayMax(heights));
            thisCarousel.css({
              height: arrayMax(heights)+'px'
            });
          }else{
            thisCarousel.css({
              height: 'auto'
            });
          }
        }

        var carouselImagesHaveLoaded = false;
        //wait for images to preload and then resize the carousel. Also resize carousel on all window resize events.
        carouselItems.children('img').imgpreload({
          all:resizeCarousel
        });

        thisCarousel.addClass('carousel-multiple');

        if (thisCarousel.carousel) {
          thisCarousel.carousel({
            interval: 5000,
            pause:'hover'
          });
        }
        //set up indicators
        var carouselIndicatorsContainer = $('<ol>',{'class':'carousel-indicators'});
        var carouselIndicators = $([]);

        for(var i = 0; i<carouselItems.length;i++){
          // check to see if there are multiple slides
          if(carouselItems.length > 1) {
            var thisCarouselIndicator = $('<li>');
            thisCarouselIndicator.attr('data-slide-to',''+i);
            if(i == 0){
              thisCarouselIndicator.addClass('indicator-active');
            }
            thisCarouselIndicator.appendTo(carouselIndicatorsContainer);
            carouselIndicators = carouselIndicators.add(thisCarouselIndicator); //add to carouselIndicators jquery object
          }
        }

        //resize events
        $(window).resize(resizeCarousel);
        resizeCarousel();

        carouselIndicatorsContainer.prependTo(thisCarousel);

        carouselIndicators.bind('click', function(e){
          var gotoIndex = carouselIndicators.index(this); // find the clicked indicator navigation
          carouselIndicators.removeClass('indicator-active'); // reset the indicator navigation
          $(this).addClass('indicator-active'); // mark selected to the indicator navigation
          thisCarousel.carousel(gotoIndex); // navigate to the selected slider
        });


        thisCarousel.bind('slid', function(e){ //This event is fired when the carousel has finished its slide transition.
          var currentIndex = carouselItems.index(carouselItems.filter('.active')); // find the index of current slide
          carouselIndicators.removeClass('indicator-active'); // reset the indicators
          carouselIndicators.eq(currentIndex).addClass('indicator-active'); // update the indicators

        });


      }else{
        //if there's only one item, adjust the carousel to reflect this
        carouselItems.eq(0).addClass('indicator-active');
        thisCarousel.addClass('carousel-single');
      }

    }

  });

  /*/////////////////////////
  // Shared Roles Accordion Logic
  /////////////////////////*/

  var $rolesAccordions = $('.fs-accordion');

  $rolesAccordions.each(function(){

    var $accordionContainer = $(this);

    //Opens the correct section if it finds a hash on the url at page load
    //Linked to the ID attribute on the section

    var $accordionContents = $(".accordion-content",$accordionContainer);
    var $accordionHandles = $(".accordion-handle",$accordionContainer);

    //omniture tracking for expander handles with data-omniture-key
    $(document).on('expander.stateChanged',function(event){
      var currentlyExpandedHandle = $accordionHandles.filter('.triggered');

      var anySectionIsOpen;
      if(currentlyExpandedHandle.length == 0){
        anySectionIsOpen = false;
      }else{
        anySectionIsOpen = true;
      }

      if(event.newState == 'expanded'){

        var currentlyExpandedContent = $(currentlyExpandedHandle.attr('href')); //href being '#[id of content div]' which is the selector

        //here we have to strip the ID so that we can set the hash without scrolling the page to that ID.
        var currentlyExpandedContentId = currentlyExpandedContent.attr('id');
        currentlyExpandedContent.removeAttr('id');

        //set the hash to the section so that someone can get back easily
        window.location.replace('#'+currentlyExpandedContentId);

        //reinstate the ID
        currentlyExpandedContent.attr('id',currentlyExpandedContentId);

        var omnitureKey = currentlyExpandedHandle.data('omniture-key');

        if(typeof omnitureKey != 'undefined'){
          omnitureTrackPage(omnitureKey);
        }
      }else if(!anySectionIsOpen){
        //set the hash to '#_' because '#' will cause a scroll to _top
        window.location.replace('#_');
      }



    });


    // Default behavior is to have all tabs collapsed
    $accordionContents.hide();
    $accordionHandles.removeClass('triggered');

    //if the hash on page load matches the HREF of a trigger element, activate it
    if ($accordionContents.length > 0 && window.location.hash) {
      var hash = window.location.hash
        .substring(1) //remove the '#'
        .replace(/[^A-Za-z0-9\-_]/g,''); //remove all non-basic characters to prevent jquery selector attacks.
      $accordionContents.hide();
      $accordionHandles.removeClass('triggered');

      var contentToOpenAtLoadTime = $('.accordion-content#'+hash,$accordionContainer);

      if(contentToOpenAtLoadTime.length > 0){
        contentToOpenAtLoadTime.show(0); //show the content
        var $activeHandle = $accordionHandles.filter("[href='#"+hash+"']");
        $activeHandle.addClass('triggered'); //add triggered class to handle

        //jump to the title instead of the content
        setTimeout(function(){
          console.log($activeHandle.offset().top);
          $(window).scrollTop($activeHandle.offset().top - $(window).width() * .03); //scroll to target link but also rewind 3% of the browser width
        },1000);
      }else{
        window.location.replace('#_'); //if no match, redirect to #_
      }

      //note: if we want to disable scrolling entirely, we'll have to figure out a way to implement the markup that doesn't require ID#'d divs, or setting window.scrolltop = 0 each page load

    }

    //Closes all other sections when a section is opened (accordion behavior)
    $accordionHandles.click(function (e) {

      if( !$(this).hasClass('triggered') ) {
        $accordionContents.hide();
        $accordionHandles.removeClass('triggered');
        $(this).addClass('triggered');
      }

    });

  });

});

function omnitureTrackPage(pageName) {
  if(s) {
    var channel = 'FamilySearch: Indexing:';
    s.channel = channel;
    s.pageName = channel + ' ' + pageName;
    s.t();
  }
}
